(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6950],{

/***/ 91234:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent",
      function () {
        return __webpack_require__(3377);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50943);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38579);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40581);
/* harmony import */ var _LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var defaultLogoNames = [
    "axa",
    "expedia",
    "roche",
    "unilever",
    "samsung",
    "marriott",
    "thunes",
    "shopify",
    "philips",
    "reckitt", 
];
var LogoSection = function(param) {
    var containerClassName = param.containerClassName, className = param.className, imageContainerClassName = param.imageContainerClassName, imageClassName = param.imageClassName, _logos = param.logos, logos = _logos === void 0 ? defaultLogoNames : _logos, _isColor = param.isColor, isColor = _isColor === void 0 ? false : _isColor, _removeBackground = param.removeBackground, removeBackground = _removeBackground === void 0 ? false : _removeBackground, _opacity = param.opacity, opacity = _opacity === void 0 ? 100 : _opacity;
    var finalLogos = logos.length <= 6 ? defaultLogoNames : logos;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), mappedLogos = ref[0], setMappedLogos = ref[1];
    var showLogos = function() {
        // This technique is to reduce the main execution thread
        var items = [];
        finalLogos.map(function(logo, index) {
            items.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imageContainer), imageContainerClassName),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    alt: logo,
                    height: 50,
                    width: 100,
                    layout: "intrinsic",
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image), imageClassName),
                    src: "/img/logos/".concat(isColor ? "color/" : "white/").concat(logo, ".svg")
                })
            }, index));
        });
        setMappedLogos(items);
    };
    if (!mappedLogos && finalLogos.length) {
        showLogos();
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_3__/* .SectionContainer */ .S, {
        anchor: "logos",
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sectionContainer), removeBackground && (_LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().removeBackground), containerClassName),
        style: {
            opacity: "".concat(opacity, "%")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_3__/* .Section */ .$, {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().section), className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_LogoSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().marquee)),
                children: [
                    mappedLogos,
                    mappedLogos
                ]
            })
        })
    });
};
LogoSection.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    imageContainerClassName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    imageClassName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    removeBackground: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    isColor: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    opacity: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number)
};
/* harmony default export */ __webpack_exports__["default"] = (LogoSection);


/***/ }),

/***/ 3377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ talent; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Layout/Layout.jsx
var Layout = __webpack_require__(93651);
// EXTERNAL MODULE: ../@hiredigital/ui/src/LoadingArea/index.jsx
var LoadingArea = __webpack_require__(84585);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/components/PageComponents/Hero/Hero.jsx
var Hero = __webpack_require__(92256);
// EXTERNAL MODULE: ./src/components/PageComponents/Hero/HeroButton/index.jsx
var HeroButton = __webpack_require__(61522);
// EXTERNAL MODULE: ./src/components/UserMasonry/UserMasonry.jsx + 1 modules
var UserMasonry = __webpack_require__(41551);
// EXTERNAL MODULE: ./src/components/PageComponents/Hero/TalentHero/Styles.module.scss
var Styles_module = __webpack_require__(79221);
var Styles_module_default = /*#__PURE__*/__webpack_require__.n(Styles_module);
;// CONCATENATED MODULE: ./src/components/PageComponents/Hero/TalentHero/TalentHero.jsx







var TalentHero = function(param) {
    var users = param.users, order = param.order, title = param.title, description = param.description, customerNames = param.customerNames, hideCustomers = param.hideCustomers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.ZP, {
            parent: Hero/* default.Page.TALENT */.ZP.Page.TALENT,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Styles_module_default()).heroContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: Hero/* default.Styles.heroLeft */.ZP.Styles.heroLeft,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (Styles_module_default()).heroTitle,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Styles_module_default()).heroDescription,
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Styles_module_default()).heroCta,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroButton/* default */.Z, {
                                    type: HeroButton/* default.Type.WHITE */.Z.Type.WHITE,
                                    title: "",
                                    to: "/talent/register",
                                    children: "Apply Now for Free"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: Hero/* default.Styles.heroRight */.ZP.Styles.heroRight,
                        children: users && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMasonry/* default */.Z, {
                            type: UserMasonry/* default.MasonryType.TALENT */.Z.MasonryType.TALENT,
                            bottom: true,
                            users: users,
                            order: order || users
                        })
                    })
                ]
            })
        })
    });
};
TalentHero.propTypes = {
    users: (prop_types_default()).array,
    order: (prop_types_default()).array,
    title: (prop_types_default()).string,
    description: (prop_types_default()).string,
    talentCtaLinkTo: (prop_types_default()).string,
    talentCtaLabel: (prop_types_default()).string,
    brandCtaLinkTo: (prop_types_default()).string,
    brandCtaLabel: (prop_types_default()).string,
    customerNames: (prop_types_default()).array
};
/* harmony default export */ var TalentHero_TalentHero = (TalentHero);

// EXTERNAL MODULE: ./src/components/Section/index.jsx
var Section = __webpack_require__(50943);
// EXTERNAL MODULE: ../@hiredigital/ui/src/Text/Text.jsx
var Text = __webpack_require__(10966);
// EXTERNAL MODULE: ./src/components/PageComponents/TalentExplainer/TalentExplainer.module.scss
var TalentExplainer_module = __webpack_require__(55074);
var TalentExplainer_module_default = /*#__PURE__*/__webpack_require__.n(TalentExplainer_module);
;// CONCATENATED MODULE: ./src/components/PageComponents/TalentExplainer/TalentExplainer.jsx




var TalentExplainer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionContainer */.S, {
        type: Section/* SectionContainer.Type.LIGHTBLUE */.S.Type.LIGHTBLUE,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
            className: Section/* Section.Styles.ruler */.$.Styles.ruler,
            title: "What is Hire Digital?",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TalentExplainer_module_default()).info,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TalentExplainer_module_default()).itemLeft,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: Text/* default.Color.BLUE */.Z.Color.BLUE,
                            className: (TalentExplainer_module_default()).itemTitle,
                            children: "Hire Digital is a network of the best content marketing talent and digital experts around the world."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TalentExplainer_module_default()).itemRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Hire Digital works with some of the fastest growing, transformative businesses worldwide. Enabled by technology, Hire Digital matches its network of experienced talent to relevant projects from brands including Samsung, Grab, Unilever, Expedia, Carousell and Philips. With Hire Digital, talent can focus on what they love to do, while we take care of the rest."
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TalentExplainer_TalentExplainer = (TalentExplainer);

// EXTERNAL MODULE: ./src/components/PageComponents/LogoSection/LogoSection.jsx
var LogoSection = __webpack_require__(22668);
;// CONCATENATED MODULE: ./src/pages/talent/index.jsx




// import TalentHero from '@components/PageComponents/Hero/TalentHero/TalentHero';





var TalentCta = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3770).then(__webpack_require__.bind(__webpack_require__, 8160));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8160)
            ];
        }
    }
});
var TalentWhyJoin = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5558).then(__webpack_require__.bind(__webpack_require__, 15558));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15558)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingArea/* default */.Z, {
            height: 451
        });
    },
    ssr: false
});
var TalentWorkflow = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8566).then(__webpack_require__.bind(__webpack_require__, 98566));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98566)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingArea/* default */.Z, {
            height: 486
        });
    },
    ssr: false
});
var TalentRequests = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3089).then(__webpack_require__.bind(__webpack_require__, 43089));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43089)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingArea/* default */.Z, {
            height: 528
        });
    },
    ssr: false
});
var TalentTestimonial = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8291).then(__webpack_require__.bind(__webpack_require__, 98291));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98291)
            ];
        }
    },
    ssr: false
});
var TalentWhatToExpect = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8211).then(__webpack_require__.bind(__webpack_require__, 38211));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38211)
            ];
        }
    },
    ssr: false
});
var PostSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7448).then(__webpack_require__.bind(__webpack_require__, 59450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59450)
            ];
        }
    },
    ssr: false
});
var RightTriangle = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7037).then(__webpack_require__.bind(__webpack_require__, 57037));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57037)
            ];
        }
    },
    ssr: false
});
var LeftTriangle = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6322).then(__webpack_require__.bind(__webpack_require__, 46322));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46322)
            ];
        }
    },
    ssr: false
});
var Talent = function(_param) {
    var hero = _param.hero, head = _param.head, footer = _param.footer, customerNames = _param.customerNames, cardUsers = _param.cardUsers, testimonials = _param.testimonials, posts = _param.posts, postData = _param.postData, props = (0,_object_without_properties/* default */.Z)(_param, [
        "hero",
        "head",
        "footer",
        "customerNames",
        "cardUsers",
        "testimonials",
        "posts",
        "postData"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        footerData: footer,
        pageHead: head,
        variant: Layout/* default.Variants.TALENT */.Z.Variants.TALENT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentHero_TalentHero, {
                customerNames: customerNames,
                users: cardUsers,
                title: hero.title,
                description: hero.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoSection["default"], {
                clients: customerNames
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentExplainer_TalentExplainer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentWhyJoin, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentWorkflow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentRequests, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentTestimonial, {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentWhatToExpect, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentCta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSection, {
                posts: posts,
                postData: postData
            })
        ]
    });
};
Talent.propTypes = {
    hero: (prop_types_default()).object,
    head: (prop_types_default()).object,
    footer: (prop_types_default()).object,
    cardUsers: (prop_types_default()).array
};
var __N_SSG = true;
/* harmony default export */ var talent = (Talent);


/***/ }),

/***/ 79221:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"Styles_heroContainer__4tQKZ","rightCircleOneAlt":"Styles_rightCircleOneAlt__xtiNu","heroTitle":"Styles_heroTitle__X3PiG","heroDescription":"Styles_heroDescription__YCNrr","heroCta":"Styles_heroCta__1AxAa","sliderEnterprise":"Styles_sliderEnterprise__Ft_JM"};

/***/ }),

/***/ 40581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"LogoSection_sectionContainer__AVAX1","removeBackground":"LogoSection_removeBackground__hCzmA","section":"LogoSection_section__vI4SV","fadein":"LogoSection_fadein__Mimkf","superSection":"LogoSection_superSection___t7X_","marquee":"LogoSection_marquee__QjQCf","rightRow":"LogoSection_rightRow__hS3wX","marqueeRight":"LogoSection_marqueeRight__j_IQM","imageContainer":"LogoSection_imageContainer__dhQbE","image":"LogoSection_image__uUxk6"};

/***/ }),

/***/ 55074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info":"TalentExplainer_info__d62Oi","itemTitle":"TalentExplainer_itemTitle__en30U","itemLeft":"TalentExplainer_itemLeft__T_dqP","itemRight":"TalentExplainer_itemRight__xLENM"};

/***/ }),

/***/ 31373:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [856,6151,8579,3651,4043,9774,2888,179], function() { return __webpack_exec__(91234); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);